import { ClientStoreEffects } from "@root/platform/service-order/new-client/client-store/effects";
import { VehicleEffects } from "@root/platform/service-order/new-vehicle/vehicle-store/effects";
import { ServiceOrderStoreEffects } from "@root/platform/service-order/service-order-store/effects";


export const effects = [
  ClientStoreEffects,
  ServiceOrderStoreEffects,
  VehicleEffects
];
